/* Price-details popover: one popover ([data-pinfo-pop]) serves every [data-pinfo] button on the page.
   Desktop (hover + fine pointer): opens on hover, stays while the pointer is over the popover. Touch: tap toggles.
   Buttons rendered later by JS (BFCM builder, compare) work too because everything is delegated. */
(function () {
  if (window.__pinfo) return;
  window.__pinfo = true;
  var cur = null, pop = null, timer = null;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function getPop() { return pop || (pop = document.querySelector('[data-pinfo-pop]')); }
  function place(btn) {
    var p = getPop(), r = btn.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    var w = Math.min(320, vw - 32);
    p.style.width = w + 'px';
    var left = Math.min(Math.max(16, r.left + r.width / 2 - w / 2), vw - w - 16);
    p.style.left = left + 'px';
    var h = p.offsetHeight, top = r.bottom + 10, above = false;
    if (top + h > vh - 8) {
      if (r.top - 10 - h >= 8) { above = true; top = r.top - 10 - h; }
      else top = Math.max(8, vh - 8 - h);
    }
    p.style.top = top + 'px';
    p.classList.toggle('is-above', above);
    p.style.setProperty('--pinfo-ax', Math.max(14, Math.min(w - 14, r.left + r.width / 2 - left)) + 'px');
  }
  function open(btn) {
    var p = getPop(); if (!p) return;
    if (cur && cur !== btn) cur.setAttribute('aria-expanded', 'false');
    cur = btn; btn.setAttribute('aria-expanded', 'true');
    place(btn); p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
  }
  function close() {
    clearTimeout(timer);
    if (!cur) return;
    cur.setAttribute('aria-expanded', 'false'); cur = null;
    var p = getPop(); if (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pinfo]');
    if (b) { e.preventDefault(); e.stopPropagation(); if (cur === b) close(); else open(b); return; }
    if (e.target.closest('[data-pinfo-close]')) { e.preventDefault(); close(); return; }
    var p = getPop();
    if (p && p.contains(e.target)) return;
    close();
  }, true);
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var b = e.target.closest('[data-pinfo]'), p = getPop();
      if (b) { clearTimeout(timer); timer = setTimeout(function () { open(b); }, 60); return; }
      if (p && p.contains(e.target)) { clearTimeout(timer); return; }
      if (cur) { clearTimeout(timer); timer = setTimeout(close, 200); }
    });
    document.addEventListener('mouseout', function (e) {
      var b = e.target.closest('[data-pinfo]');
      if (b && !cur) clearTimeout(timer);
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.addEventListener('scroll', function () { if (cur) close(); }, { passive: true, capture: true }); /* capture: also closes when a sheet/drawer panel scrolls */
  window.addEventListener('resize', function () { if (cur) close(); });
})();
